import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import IconDelete from "@material-ui/icons/Delete";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(() => ({
  selector: {
    position: "relative",
    height: "56px",
    borderRadius: "4px",
    border: "1px solid #c4c4c4",
  },
  selectorLabel: {
    position: "absolute",
    top: "16px",
    left: "28px",
    color: "rgba(0, 0, 0, 0.54)",
    userSelect: "none",
    cursor: "default",
    transition: "all 0.3s ease",
  },
  selectorLabelActive: {
    transform: "translate(-28px, -29px) scale(0.75)",
    background: "#ffffff",
    padding: "0 8px",
  },
  selectorMain: {
    height: "56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 15px",
  },
  selectorFileInput: {
    display: "none",
  },
}));

function FileSelector(props) {
  const classes = useStyles();

  function handleOpenFile(e) {
    props.onChange(e.target.files[0]);
  }

  return (
    <div className={classes.selector}>
      <Typography
        className={classNames(classes.selectorLabel, {
          [classes.selectorLabelActive]: props.file,
        })}
      >
        {props.required ? `${props.label} *` : props.label}
      </Typography>
      <div className={classes.selectorMain}>
        {props.file && (
          <React.Fragment>
            <Typography>{props.file.name}</Typography>
            <IconButton onClick={() => props.onChange(null)} edge="end">
              <IconDelete />
            </IconButton>
          </React.Fragment>
        )}
        {!props.file && (
          <React.Fragment>
            <Typography></Typography>
            <div>
              <input
                accept={props.accept}
                className={classes.selectorFileInput}
                id="file-selector-input"
                type="file"
                onChange={handleOpenFile}
              />
              <label htmlFor="file-selector-input">
                <Button variant="contained" color="primary" component="span">
                  Carregar
                </Button>
              </label>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

FileSelector.propTypes = {
  file: PropTypes.object,
  label: PropTypes.string,
  required: PropTypes.bool,
  accept: PropTypes.string,
  onChange: PropTypes.func,
};

FileSelector.defaultProps = {
  file: null,
  label: "",
  required: false,
  accept: "",
  onChange: () => {},
};

export default FileSelector;
